export const CSV_UPLOADING = 'CSV_UPLOADING';

export function csvUploading(uploading) {
  return {
    type: CSV_UPLOADING,
    uploading,
  };
}
